// extracted by mini-css-extract-plugin
module.exports = {"reviews-container":"Reviews_reviews-container__1TzHa"};